import fetch from "../fetch";

export default ({ values, dealCode }) => {
  return fetch({
    path: dealCode ? `/clo/deals/${dealCode}` : "/clo/deals",
    method: dealCode ? "PUT" : "POST",
    data: values
  });
};
